module.exports = __webpack_public_path__ + "img/gift-ranking_bg.e036ebe9.png";